import type { ReactNode } from 'react';
import { Component } from 'react';

import AnimateHeight from '@skyscanner/backpack-web/bpk-animate-height';
import {
  BpkButtonV2,
  BUTTON_TYPES,
} from '@skyscanner/backpack-web/bpk-component-button';
import BpkLink from '@skyscanner/backpack-web/bpk-component-link';

import { withI18n } from '../../contexts/i18n';

import type { I18nService } from '@shared/types/i18n';
import type { Maybe } from '@shared/types/utils';

import STYLES from './SeeMoreLess.module.scss';

type Props = {
  i18n: I18nService;
  children: ReactNode | Function;
  className?: Maybe<string>;
  buttonClassName?: Maybe<string>;
  expandable?: boolean;
  toggleCb?: Maybe<Function>;
  dataTestId?: Maybe<string>;
  link?: boolean;
};

type State = {
  expanded: boolean;
};

const defaultProps = {
  className: null,
  buttonClassName: null,
  expandable: true,
  toggleCb: null,
  dataTestId: null,
  link: false,
};

class SeeMoreLess extends Component<Props, State> {
  static defaultProps = defaultProps;

  state: State = {
    expanded: false,
  };

  onToggle = () => {
    const { expanded } = this.state;
    this.setState({ expanded: !expanded }, () => {
      if (this.props.toggleCb) {
        this.props.toggleCb();
      }
    });
  };

  render() {
    const { expanded } = this.state;
    const {
      buttonClassName,
      children,
      className,
      dataTestId,
      expandable,
      i18n,
      link,
    } = this.props;

    const labelKey = expanded ? 'Button_viewLess' : 'Button_viewMore';

    let childrenDom;
    let childrenHeight;
    if (typeof children === 'function') {
      childrenDom = children(expanded);
      childrenHeight = 'auto';
    } else {
      childrenDom = children;
      childrenHeight = expanded ? 'auto' : 0;
    }

    const classNames = [STYLES.SeeMoreLess];
    if (className) {
      classNames.push(className);
    }

    const buttonClassNames = [STYLES.SeeMoreLess__btn];
    if (buttonClassName) {
      buttonClassNames.push(buttonClassName);
    }

    return (
      <div className={classNames.join(' ')} data-test-id={dataTestId}>
        <AnimateHeight duration={200} height={childrenHeight}>
          {childrenDom}
        </AnimateHeight>
        {expandable && (
          <div className={buttonClassNames.join(' ')}>
            {link ? (
              <BpkLink
                as="button"
                onClick={this.onToggle}
                data-test-id="see-more-less-button"
              >
                {i18n.translate(labelKey)}
              </BpkLink>
            ) : (
              <BpkButtonV2
                type={BUTTON_TYPES.secondary}
                onClick={this.onToggle}
                data-test-id="see-more-less-button"
              >
                {i18n.translate(labelKey)}
              </BpkButtonV2>
            )}
          </div>
        )}
      </div>
    );
  }
}

export default withI18n(SeeMoreLess);
